import { Alert, Stack, Typography } from "@mui/material";
import Layout from "../Frames/Layout";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useEffect } from "react";
import API from "../../services/API";
import Loader from "../Tools/Loader";
import CourseDocs from "./Common/CourseDocs";
import CourseDescription from "./Common/CourseDescription";
import CourseTeachers from "./Common/CourseTeachers";
import CourseDisciplines from "./Common/CourseDisciplines";


export default function EventOverview(){

    const {id} = useParams()

    const [course, setCourse] = useState(null)
    const [status, setStatus] = useState('loading')

    const statusIs = str => str === status

    useEffect(() => {

        if(id !== 'new'){

            API.get(`/design/courses/${id}`)
                .then(r => {
                    setCourse(r.data)
                    setStatus('ready')
                })
                .catch(_ => setStatus('error'))

        }else{

            setStatus('new')
        }

    }, [id])


    return <Layout menu='organize' tab='overview'>


        <Stack spacing={4} sx={{maxWidth: 600, margin: 'auto', pt: 4, pb: 4}}>


            <Typography variant='h1'>Détails de l'événement</Typography>


            {course && <>

                <CourseDescription 
                    course={course} 
                    onChange={course => setCourse(course)}
                />

                <CourseDocs id={id} />

                <CourseDisciplines id={id} />

                <CourseTeachers id={id} />

            </>}


            {statusIs('loading') && <Loader />}


            {statusIs('new') &&
                <Alert severity="warning">
                    Veuillez finaliser la <Link to={`/organize/${id}`}><u>création de l'événement</u> avant de continuer</Link>.
                </Alert>
            }

        </Stack>

    </Layout>
}